export default __webpack_public_path__ + "static/media/roadmap.3628ad62.png";